export function assign(target, source) {
	if (target && typeof target === 'object') Object.assign(target, source);
}
